import { render, staticRenderFns } from "./dyTransfer.vue?vue&type=template&id=516628c6&scoped=true&"
import script from "./dyTransfer.vue?vue&type=script&lang=js&"
export * from "./dyTransfer.vue?vue&type=script&lang=js&"
import style0 from "./dyTransfer.vue?vue&type=style&index=0&id=516628c6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516628c6",
  null
  
)

export default component.exports